import { render, staticRenderFns } from "./ZTabsHead.vue?vue&type=template&id=208f2e21&scoped=true&"
import script from "./ZTabsHead.vue?vue&type=script&lang=js&"
export * from "./ZTabsHead.vue?vue&type=script&lang=js&"
import style0 from "./ZTabsHead.vue?vue&type=style&index=0&id=208f2e21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208f2e21",
  null
  
)

component.options.__file = "ZTabsHead.vue"
export default component.exports